import { MetadataModel, ProviderInfoModel, ToolConfigModel, ToolModel } from '@/models/learning-registry/learning-registry';
import { checkCDNUrl, isEmptyValue } from '@/utils/utils';

export class LearningRegistrySerializer {

  static get instance() {
    return this.INSTANCE;
  }

  private static INSTANCE = new LearningRegistrySerializer();

  public serializeToolProviderList(payload: any, categoryList: any) {
    const payloadList = payload ? payload.providers : [];
    for (const iterator of payloadList) {
      iterator.allSubjectList = [];
      for (const iteratorTool of iterator.toolList) {
        iteratorTool.isShowSecret = false;
        iteratorTool.category = null;
        iteratorTool.subject = [];
        for (const category of categoryList) {
          if (!isEmptyValue(iteratorTool.metadata[category.id])
            && !isEmptyValue(iteratorTool.metadata[category.id].length > 0)) {
            iteratorTool.category = category.id;
            iteratorTool.subject = iteratorTool.metadata[category.id];
            for (const subject of iteratorTool.metadata[category.id]) {
              iterator.allSubjectList.push(subject);
            }
          }
        }
      }
    }
    return payloadList;
  }

  public serializeToolRegistryList(payload: any) {
    let toolList: any = [];
    const providersList: any = payload.providers ? payload.providers : [];
    providersList.forEach((provider: any) => {
      const providerTools = provider.toolDetails || null;
      toolList = toolList.concat(this.parseCategoriesDetails(provider, providerTools));
    });
    const toolObject = {
      providers: toolList,
      totalCount: payload.totalCount,
    };

    return toolObject;
  }


  public serializeSubscribeToolRegistryList(payload: any, registryType: string) {
    const subscribedPayload = payload.subscribedTools ? payload.subscribedTools : [];
    let subscribedTools: any = [];
    subscribedPayload.forEach((toolData: any) => {
      toolData.registryType = registryType;
      if (registryType === 'tool_registry') {
        subscribedTools = subscribedTools.concat(this.parseCategoriesDetails(toolData, toolData));
      } else {
        const publisherInfo: any = this.normalizePublisherInfo(toolData);
        publisherInfo.toolData = toolData ? this.serializeToolData(toolData) : null;
        subscribedTools.push(publisherInfo);
      }
    });

    const payloadObject = {
      subscribedTools,
      totalCount: payload.totalCount,
    };
    return payloadObject;
  }

  public serializeProviderList(payload: any) {
    const providers = payload.providers ? payload.providers : [];
    for (const iterator of providers) {
      iterator.logo = iterator.thumbnail ? checkCDNUrl(iterator.thumbnail) : '';
    }
    return providers;
  }

  public serializeContentProviderList(payload: any) {
    const publishers = payload.contentRegistry ? payload.contentRegistry : [];
    const publishersList: any = [];
    publishers.forEach((publisher: any) => {
      const toolData = publisher.toolDetails || null;
      const publisherInfo: any = this.normalizePublisherInfo(publisher);
      publisherInfo.toolData = toolData ? this.serializeToolData(toolData) : null;
      publishersList.push(publisherInfo);
    });
    const payloadObject = {
      contentRegistry: publishersList,
      totalCount: payload.totalCount,
    };
    return payloadObject;
  }

  public serializeDropDownToolList(payload: any) {
    const providers = payload.toolsList ? payload.toolsList : [];
    const toolList: any = [];
    for (const iterator of providers) {
      iterator.logo = iterator.thumbnail ? checkCDNUrl(iterator.thumbnail) : '';
      const toolData = this.serializeToolData(iterator);
      toolList.push(toolData);
    }
    return toolList;
  }


  public serializeToolData(toolPayload: any) {
    const toolConfig = toolPayload.toolConfig;
    const metadata = toolPayload.metadata;

    const toolData: any = {
      id: toolPayload.id || toolPayload.toolId,
      name: toolPayload.name || toolPayload.toolName,
      description: toolPayload.description || toolPayload.toolDescription,
      clientId: toolPayload.clientId,
      subscribeStatus: toolPayload.subscribeStatus,
      code: toolPayload.code,
      registryType: toolPayload.registryType,
      tenantId: toolPayload.tenantId,
      toolCategory: toolPayload.toolCategory,
      toolType: toolPayload.toolType,
      toolVisibility: toolPayload.toolVisibility,
      providerId: toolPayload.learningToolProviderId,
      publisherId: toolPayload.publisherId,
      audience: toolPayload.audience || null,
      thumbnail: checkCDNUrl(metadata.thumbnail),
      subject: toolPayload.subject || null,
      category: toolPayload.category || null,
      grades: toolPayload.grades && toolPayload.grades.length ? toolPayload.grades : [],
      rating: metadata.rating,
      toolMetrics: toolPayload.metrics || {},
      customParams: metadata.customParams || null,
      subjectData: toolPayload.subjectData || null,
      gradeData: toolPayload.gradeData || [],
      categoryData: toolPayload.categoryData || {},
      ...this.normalizeToolConfig(toolConfig, toolPayload.toolType),
    };
    if (toolData.redirectURI) {
      toolData.redirectURI = toolData.redirectURI.toString();
    }
    return toolData;
  }


  public normalizeProviderInfo(payload: any) {
    const providerInfo: ProviderInfoModel = {
      name: payload.name,
      website: '',
      image: payload.thumbnail,
      description: payload.description,
      partner_id: payload.partner,
    };
    return providerInfo;
  }

  public normalizeToolData(payload: any) {
    const metadata: MetadataModel = {
      rating: payload.rating,
      customParams: payload.customParams || null,
    };
    const { categories, subjects, grades }  = this.serilaizeCategoryData(payload.categoryInfo, payload);

    const toolData: ToolModel = {
      name: payload.name,
      description: payload.description,
      clientId: payload.clientId,
      code: payload.code || payload.toolCategory,
      registryType: payload.registryType,
      tenantId: '',
      toolCategory: payload.toolCategory,
      toolType: payload.toolType,
      toolVisibility: payload.toolVisibility || 'visible',
      metadata,
      toolMetrics: payload.toolMetrics || {},
      audience: payload.audience || 'student',
      categories,
      subjects,
      grades,
      thumbnail: payload.thumbnail,
      toolConfig: this.normalizeToolConfig(payload),
      defaultLaunchContainer: payload.defaultLaunchContainer || 'Embed',
    };

    if (!payload.isPublisher) {
      toolData.learningToolProviderId = payload.providerId;
    } else {
      toolData.publisherId = payload.providerId;
    }

    return toolData;
  }

  public serializePublisherInfo(payload: any) {
      const infoData = {};
      const grades = (payload.grades || []).map((item: any) => item.id);
      const publisherData = {
        thumbnail: payload.thumbnail,
        name: payload.name || '',
        iconUrl: payload.contentURL,
        description: payload.description || '',
        info: infoData,
        partner_id: payload.partner,
        groupCode: payload.contentType,
        website: payload.contentURL,
        category: payload.category,
        subject: payload.subject,
        grades,
      };
      return publisherData;
  }

  public serializeConfigTool(tool: any) {
    return {
      subscribe_id: tool.id,
      tool_config: this.normalizeToolConfig(tool),
      subscription_status: tool.subscribeStatus,
      client_id: tool.clientId,
    };
  }

  private normalizeCategoryData(providerTools: any) {
    const subjectList = providerTools.subjects || {};
    const categoriesList = providerTools.categories || [];
    const gradesList = providerTools.grades || {};
    const subjects: any = {};
    const grades: any = {};
    Object.keys(subjectList).forEach((item: any) => {
      subjects[item] = subjectList[item].map((subject: any) => subject.id);
    });
    Object.keys(gradesList).forEach((item: any) => {
      grades[item] = gradesList[item].map((grade: any) => grade.id);
    });
    return {
      categories: categoriesList,
      subjects,
      grades,
    };
  }

  private parseCategoriesDetails(provider: any, providerTools: any) {
    const toolList: any = [];
    const subjectList = providerTools.subjects || null;
    const categoriesList = providerTools.categories || [];
    const gradesList = providerTools.grades || [];
    providerTools.categoryData = this.normalizeCategoryData(providerTools);

    const parseToolObj = (providerItem: any, toolData: any) => {
      const parseToolData: any = this.serializeToolData(toolData);
      parseToolData.providerDetails = providerItem;
      parseToolData.partner = providerItem.partner_id;
      toolList.push(parseToolData);
    };
    if (categoriesList && categoriesList.length) {
      categoriesList.forEach((catItem: any) => {
        const activeSubjects = subjectList[catItem] || [];
        if (activeSubjects && activeSubjects.length) {
          activeSubjects.forEach((subItems: any) => {
            const parseGrades = (gradesList[subItems.id] || []).map((item: any) => {
                item.grade = item.title;
                return item;
            });
            const toolData = Object.assign({}, providerTools, {
              category: catItem,
              subject: subItems.id,
              grades: parseGrades,
              subjectData: subItems,
            });
            parseToolObj(provider, toolData);
          });
        } else {
          const toolData = Object.assign({}, providerTools, {
            category: catItem,
            subject: null,
            grades: [],
            subjectData: null,
          });
          parseToolObj(provider, toolData);
        }
      });
    } else {
      const toolData = Object.assign({}, providerTools, {
        category: null,
        subject: null,
        grades: [],
        subjectData: null,
      });
      parseToolObj(provider, toolData);
    }
    return toolList;
  }

  private serilaizeCategoryData(categoryInfo: any, toolData: any) {
    const defaultCateogry = {
      categories: [],
      subjects: {},
      grades: {},
    };
    const categoryItems = toolData.categoryData || defaultCateogry;
    const { subjects, grades } = categoryItems;
    let {categories} = categoryItems;
    if (categoryInfo && categoryInfo.length) {
      categoryInfo.forEach((category: any) => {
        categories = [...new Set([...categories, category.id])];
        if (category.subjects && category.subjects) {
          subjects[category.id] = category.subjects.map((item: any) => item.id);
          category.subjects.forEach((subject: any) => {
            if (subject.grades) {
              grades[subject.id] = subject.grades.map((item: any) => item.id);
            }
          });
        }
      });
    }
    return {categories, subjects, grades};
  }

  private normalizePublisherInfo(payload: any) {
    const info = payload.info || null;
    const grades = payload.grades || [];
    if (grades instanceof Array) {
      grades.map((grade: any) => {
        grade.grade = grade.title;
      });
    }
    const publisherData = {
        id: payload.id || payload.productId,
        productId: payload.productId || payload.id,
        name: payload.name || payload.productName,
        description: payload.description || payload.productDescription,
        partner: payload.partnerId,
        contentType: payload.groupCode || 'premium',
        contentURL: payload.website || payload.iconUrl,
        subject: payload.subject ? payload.subject.id : null,
        category: payload.category || null,
        grades,
        thumbnail: checkCDNUrl(payload.thumbnail),
        partnerId: payload.partnerId,
        partnerLogo: payload.partnerLogo,
        partnerName: payload.partnerName,
        partnerWebsite: payload.partnerWebsite,
        status: payload.status || payload.subscribeStatus,
        subjectData: payload.subject,
    };
    return publisherData;
  }

  /**
   * Help to parse the tool config object
   */
  private normalizeToolConfig(payload: any, toolType = null) {
    const toolConfig: ToolConfigModel = {
      redirectURI: payload.redirectURI || payload.redirect_uris || [],
      defaultLaunchContainer: payload.defaultLaunchContainer || payload.default_launch_container,
      deployment_id: payload.deployment_id || '',
    } as ToolConfigModel;
    if (payload.toolType === 'LTI' || toolType === 'LTI') {
      toolConfig.LTIVersion = payload.LTIVersion || payload.lti_version;
      toolConfig.initateLoginURL = payload.initateLoginURL || payload.initate_login_url;
      toolConfig.toolURL = payload.toolURL || payload.tool_url;
      toolConfig.publicKeyType = payload.publicKeyType || payload.public_key_type;
      if (toolConfig.publicKeyType === 'JWKS') {
        toolConfig.keysetURL = payload.keysetURL || payload.keyset_url;
      } else {
        toolConfig.publicKey = payload.publicKey || payload.public_key;
      }
    } else {
      toolConfig.username = payload.username;
      toolConfig.requestMethod = payload.requestMethod;
      toolConfig.clientCode = payload.clientCode;
    }
    if (typeof toolConfig.redirectURI === 'string') {
      toolConfig.redirectURI = toolConfig.redirectURI.split(',');
    }
    return toolConfig;
  }

}
export const learningRegistrySerializer = LearningRegistrySerializer.instance;
